// src/components/amenities/amenities.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSectionGroupSheetFragment on EGDSSheet {\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    closeText\n    sheetType\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSectionGroupOverlayFragment on ShoppingOverlayContainer {\n    overlayId\n    contentId\n    overlay {\n      __typename\n      ...ShoppingProductContentSectionGroupSheetFragment\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ShoppingLinkFragment on ShoppingLink {\n    __typename\n    actionId\n    text\n    trailingIcon {\n      id\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSectionActionFragment on ShoppingProductContentSectionAction {\n    ... on ShoppingLink {\n      __typename\n      actionId\n      text\n      trailingIcon {\n        id\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    accessibility\n    text\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    accessibility\n    decorative\n    size\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentGraphicsItemFragment on ShoppingProductContentGraphicsItem {\n    text\n    subText\n    state\n    leadingIcon {\n      ...EGDSIconFragment\n    }\n    trailingIcon {\n      actionId\n      icon {\n        ...EGDSIconFragment\n      }\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n  }\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentItemFragment on ShoppingProductContentItem {\n    ...ShoppingProductContentGraphicsItemFragment\n    ...EGDSPlainTextFragment\n    __typename\n  }\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductHeaderFragment on ShoppingProductHeader {\n    text\n    impressionAnalytics {\n      referrerId\n      linkName\n    }\n    icon {\n      id\n      description\n      token\n      size\n    }\n    subText\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentFragment on ShoppingProductContent {\n    header {\n      ...ShoppingProductHeaderFragment\n    }\n    items {\n      ...ShoppingProductContentItemFragment\n    }\n    maxColumns\n    __typename\n  }\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentElementGroupFragment on ShoppingProductContentElementGroup {\n    elements {\n      ... on ShoppingProductContent {\n        ...ShoppingProductContentFragment\n      }\n    }\n    maxColumns\n  }\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSubSectionFragment on ShoppingProductContentSubSection {\n    header {\n      ...ShoppingProductHeaderFragment\n    }\n    elements {\n      ...ShoppingProductContentElementGroupFragment\n    }\n    maxColumns\n    impressionAnalytics {\n      referrerId\n      linkName\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSectionFragment on ShoppingProductContentSection {\n    header {\n      ...ShoppingProductHeaderFragment\n    }\n    subSections {\n      ...ShoppingProductContentSubSectionFragment\n    }\n    action {\n      ...ShoppingProductContentSectionActionFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment ShoppingProductContentSectionGroupContentFragment on ShoppingProductContentSectionGroupContainer {\n    contentId\n    content {\n      __typename\n      ... on ShoppingProductContentSection {\n        ...ShoppingProductContentSectionFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment AmenitiesContentSectionFragment on ShoppingProductContentSection {\n    header {\n      ...ShoppingProductHeaderFragment\n    }\n    subSections {\n      ...ShoppingProductContentSubSectionFragment\n    }\n    action {\n      ...ShoppingProductContentSectionActionFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment AmenitiesContentSectionGroupFragment on ShoppingProductContentSectionGroup {\n    shoppingJoinListContainer {\n      actions {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        actionId\n        ... on ShoppingNavigateToOverlay {\n          overlayId\n        }\n        ... on ShoppingNavigateToURI {\n          resource {\n            value\n            ... on HttpURI {\n              relativePath\n            }\n          }\n          target\n          useRelativePath\n        }\n      }\n      overlays {\n        ...ShoppingProductContentSectionGroupOverlayFragment\n      }\n    }\n    contents {\n      ...ShoppingProductContentSectionGroupContentFragment\n    }\n    sections {\n      ...AmenitiesContentSectionFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  query AmenitiesQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    amenities(productIdentifier: $productIdentifier, context: $context) {\n      ...AmenitiesContentSectionGroupFragment\n    }\n  }\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
import React26 from "react";
import { gql as gql22, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
import { RefTarget } from "@shared-ui/ref-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
// src/components/__private/__fragments/amenities-content-section-group/amenities-content-section-group.tsx
import React25 from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
// ../internal/src/components/shopping-product-content-section-group/shopping-product-content-section-group-context.tsx
import React from "react";
import { useHistory } from "react-router-dom";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/shopping-product-content-section-group/shopping-product-content-section-group-utils.ts
var getContentSectionGroupAction = function (actions, actionId) {
  if (!actionId) {
    return null;
  }
  var _actions_find;
  return (_actions_find = actions === null || actions === void 0 ? void 0 : actions.find(function (action) {
    return action.actionId === actionId;
  })) !== null && _actions_find !== void 0 ? _actions_find : null;
};
var getContentSectionGroupOverlayContainer = function (overlayId, overlays) {
  var overlayContainer = overlays === null || overlays === void 0 ? void 0 : overlays.find(function (item) {
    return item.overlayId === overlayId;
  });
  return overlayContainer !== null && overlayContainer !== void 0 ? overlayContainer : null;
};
var getContentSectionGroupContent = function (contentId, contentContainers) {
  var contentContainer = contentContainers === null || contentContainers === void 0 ? void 0 : contentContainers.find(function (item) {
    return item.contentId === contentId;
  });
  return contentContainer !== null && contentContainer !== void 0 ? contentContainer : null;
};
// ../internal/src/components/shopping-product-content-section-group/shopping-product-content-section-group-context.tsx
var ShoppingProductContentSectionGroupContext = React.createContext(null);
var _obj;
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */, "_self"), _obj);
var DIALOG_ID = "shopping-product-content-section-group-dialog";
var ShoppingProductContentSectionGroupProvider = function (param) {
  var children = param.children,
    data = param.data;
  return /* @__PURE__ */React.createElement(ShoppingProductContentSectionGroupContext.Provider, {
    value: data
  }, children);
};
var useContentSectionGroupDialog = function (actionId) {
  var dialogId = "".concat(DIALOG_ID, "-").concat(actionId);
  return useDialog(dialogId);
};
var useContentSectionGroupAction = function (actionId) {
  var contentSectionGroupData = React.useContext(ShoppingProductContentSectionGroupContext);
  var shoppingJoinListContainer = (contentSectionGroupData || {}).shoppingJoinListContainer;
  return getContentSectionGroupAction(shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.actions, actionId);
};
var useContentSectionGroupUtils = function () {
  var contentSectionGroupData = React.useContext(ShoppingProductContentSectionGroupContext);
  var _ref = contentSectionGroupData || {},
    shoppingJoinListContainer = _ref.shoppingJoinListContainer,
    contents = _ref.contents;
  if (!contentSectionGroupData) {
    return null;
  }
  return {
    getOverlayContainer: function (overlayId) {
      return getContentSectionGroupOverlayContainer(overlayId, shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : shoppingJoinListContainer.overlays);
    },
    getContentContainer: function (contentId) {
      return getContentSectionGroupContent(contentId, contents);
    }
  };
};
var useContentSectionGroupActionCallback = function (actionId) {
  var _shoppingJoinListContainer_actions;
  var contentSectionGroupData = React.useContext(ShoppingProductContentSectionGroupContext);
  var shoppingJoinListContainer = (contentSectionGroupData || {}).shoppingJoinListContainer;
  var dialogId = "".concat(DIALOG_ID, "-").concat(actionId);
  var track = useClickTracker();
  var history = useHistory();
  var _useDialog = _sliced_to_array(useDialog(dialogId), 2),
    dialogActions = _useDialog[1];
  var contentSectionGroupAction = actionId && (shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : (_shoppingJoinListContainer_actions = shoppingJoinListContainer.actions) === null || _shoppingJoinListContainer_actions === void 0 ? void 0 : _shoppingJoinListContainer_actions.find(function (item) {
    return item.actionId === actionId;
  }));
  var analytics = (contentSectionGroupAction || {}).analytics;
  return React.useCallback(function () {
    if (!contentSectionGroupAction) {
      return;
    }
    switch (contentSectionGroupAction.__typename) {
      case "ShoppingNavigateToOverlay":
        dialogActions.openDialog();
        if (analytics) {
          track(analytics.referrerId, analytics.linkName);
        }
        break;
      case "ShoppingNavigateToURI":
        if (analytics) {
          track(analytics.referrerId, analytics.linkName);
        }
        if (contentSectionGroupAction.useRelativePath) {
          history.push(contentSectionGroupAction.resource.value);
        } else if (window && typeof window.open === "function") {
          window.open(contentSectionGroupAction.resource.value, UILinkTargetMap[contentSectionGroupAction.target]);
        }
        break;
    }
  }, [track, dialogActions, history, contentSectionGroupAction]);
};
// ../internal/src/components/shopping-product-content-section-group-content/shopping-product-content-section-group-content.tsx
import React23 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/shopping-product-content-section/shopping-product-content-section.tsx
import React22 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid5 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
// ../internal/src/components/shopping-product-content-section-action/shopping-product-content-section-action.tsx
import React8 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/shopping-link/shopping-link.tsx
import React7 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
// ../internal/src/components/shopping-product-content-section-group/shopping-product-content-section-group-action-wrapper.tsx
import React6 from "react";
// ../internal/src/components/shopping-product-content-section-group-overlay/shopping-product-content-section-group-overlay.tsx
import React5 from "react";
import { gql as gql2 } from "@apollo/client";
// ../internal/src/components/shopping-product-content-section-group-sheet/shopping-product-content-section-group-sheet.tsx
import React4 from "react";
import { gql } from "@apollo/client";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// ../internal/src/components/shopping-product-content-section-group-content/shopping-product-content-section-group-content-fc.tsx
import React2 from "react";
var ShoppingProductContentSectionGroupContentFC = function (param) {
  var data = param.data;
  var content = data.content;
  if (!(content === null || content === void 0 ? void 0 : content.length)) {
    return null;
  }
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, content.map(function (elem, index) {
    switch (elem.__typename) {
      case "ShoppingProductContentSection":
        return /* @__PURE__ */React2.createElement(ShoppingProductContentSection, {
          data: elem,
          key: "content-section-".concat(index)
        });
      default:
        return null;
    }
  }));
};
// ../internal/src/components/shopping-product-content-section-group-sheet/shopping-product-popover-sheet.tsx
import React3 from "react";
import { EGDSButtonSize, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var ShoppingProductPopoverSheet = React3.forwardRef(function (param, ref) {
  var actionId = param.actionId,
    contentContainer = param.contentContainer,
    closeDialog = param.closeDialog,
    closeText = param.closeText;
  var _content_, _subSections__elements__elements_, _subSections__elements_, _subSections_;
  var _useContentSectionGroupDialog = _sliced_to_array(useContentSectionGroupDialog(actionId), 3),
    isDialogOpen = _useContentSectionGroupDialog[0],
    dialogActions = _useContentSectionGroupDialog[1],
    DialogComponent = _useContentSectionGroupDialog[2];
  var content = (contentContainer || {}).content;
  if (!content || ((_content_ = content[0]) === null || _content_ === void 0 ? void 0 : _content_.__typename) !== "ShoppingProductContentSection") {
    return null;
  }
  var _ref = content[0] || {},
    _ref_header = _ref.header,
    header = _ref_header === void 0 ? null : _ref_header,
    _ref_subSections = _ref.subSections,
    subSections = _ref_subSections === void 0 ? [] : _ref_subSections;
  var items = ((_subSections_ = subSections[0]) === null || _subSections_ === void 0 ? void 0 : (_subSections__elements_ = _subSections_.elements[0]) === null || _subSections__elements_ === void 0 ? void 0 : (_subSections__elements__elements_ = _subSections__elements_.elements[0]) === null || _subSections__elements__elements_ === void 0 ? void 0 : _subSections__elements__elements_.items) || [];
  if (!items.length) {
    return null;
  }
  var SheetContentRender = /* @__PURE__ */React3.createElement(React3.Fragment, null, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, header && /* @__PURE__ */React3.createElement(EGDSLayoutGrid, {
    space: "two",
    justifyContent: "center",
    alignItems: "center",
    columns: ["min-content", "auto"]
  }, header.icon && /* @__PURE__ */React3.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React3.createElement("div", null, /* @__PURE__ */React3.createElement(EGDSIcon, {
    name: header.icon.id,
    size: EGDSIconSize.MEDIUM,
    spotlight: {
      theme: "info",
      background: true
    }
  }))), header && /* @__PURE__ */React3.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React3.createElement(EGDSHeading, {
    tag: "h6",
    size: 6
  }, header.text)))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    margin: {
      blockstart: "two"
    }
  }, items.map(function (elem, index) {
    return /* @__PURE__ */React3.createElement(EGDSText, {
      size: 300,
      key: "".concat(elem, "-").concat(index)
    }, elem.text);
  }))));
  return /* @__PURE__ */React3.createElement(Viewport, null, /* @__PURE__ */React3.createElement(ViewSmall, null, /* @__PURE__ */React3.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React3.createElement(DialogComponent, null, /* @__PURE__ */React3.createElement(EGDSSheet, {
    isVisible: isDialogOpen,
    type: "centered",
    centeredSheetSize: "small",
    returnFocusOnClose: true,
    liveAnnounceString: "Centered Sheet has opened",
    triggerRef: ref
  }, /* @__PURE__ */React3.createElement(EGDSSheetContent, null, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, SheetContentRender, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React3.createElement(EGDSTertiaryButton, {
    size: EGDSButtonSize.MEDIUM,
    onClick: closeDialog
  }, closeText))))))))), /* @__PURE__ */React3.createElement(ViewMedium, null, /* @__PURE__ */React3.createElement(EGDSCard, {
    overflow: false
  }, /* @__PURE__ */React3.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React3.createElement(EGDSSheet, {
    autoPosition: true,
    position: {
      inline: "leading",
      block: "leading"
    },
    applyBlockStartMargin: true,
    width: 360,
    isVisible: isDialogOpen,
    liveAnnounceString: "Popover Sheet has opened",
    type: "popover",
    triggerRef: ref,
    onDismiss: closeDialog
  }, /* @__PURE__ */React3.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */React3.createElement(EGDSTertiaryButton, {
    type: "button",
    onClick: closeDialog
  }, /* @__PURE__ */React3.createElement(EGDSIcon, {
    name: "close",
    size: EGDSIconSize.MEDIUM,
    title: "Close Sheet",
    id: "sheet-close-button"
  }))), /* @__PURE__ */React3.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    padding: {
      block: "six",
      inlinestart: "six",
      inlineend: "unset"
    }
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, SheetContentRender))))))));
});
ShoppingProductPopoverSheet.displayName = "ShoppingProductPopoverSheet";
// ../internal/src/components/shopping-product-content-section-group-sheet/shopping-product-content-section-group-sheet.tsx
var fragment = gql(_templateObject());
var _obj1;
var EGDSSheetTypeMap = (_obj1 = {}, _define_property(_obj1, "BOTTOM" /* BOTTOM */, "bottom"), _define_property(_obj1, "SIDE" /* SIDE */, "side"), _define_property(_obj1, "CENTERED" /* CENTERED */, "centered"), _define_property(_obj1, "POPOVER" /* POPOVER */, "popover"), _define_property(_obj1, "FULLSCREEN" /* FULLSCREEN */, "full"), _obj1);
var ShoppingProductContentSectionGroupSheet = React4.forwardRef(function (param, ref) {
  var actionId = param.actionId,
    contentContainer = param.contentContainer,
    data = param.data;
  var track = useClickTracker2();
  var _useContentSectionGroupDialog = _sliced_to_array(useContentSectionGroupDialog(actionId), 3),
    isDialogOpen = _useContentSectionGroupDialog[0],
    dialogActions = _useContentSectionGroupDialog[1],
    DialogComponent = _useContentSectionGroupDialog[2];
  var _data_sheetType;
  var sheetType = (_data_sheetType = data.sheetType) !== null && _data_sheetType !== void 0 ? _data_sheetType : "CENTERED" /* CENTERED */;
  var _ref = data.closeAnalytics || {},
    linkName = _ref.linkName,
    referrerId = _ref.referrerId;
  var closeDialog = React4.useCallback(function () {
    if (linkName && referrerId) {
      track(linkName, referrerId);
    }
    dialogActions.closeDialog();
  }, [data, track, dialogActions]);
  var renderToolbar = function () {
    var _data_closeText, _data_closeText1;
    var toolbarProps = {
      navigationContent: {
        onClick: closeDialog,
        navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : "close"
      },
      toolbarTitle: (_data_closeText1 = data.closeText) !== null && _data_closeText1 !== void 0 ? _data_closeText1 : ""
    };
    return /* @__PURE__ */React4.createElement(EGDSToolbar, _object_spread({}, toolbarProps));
  };
  var commonEGDSSheetProps = React4.useMemo(function () {
    return {
      isVisible: isDialogOpen,
      type: EGDSSheetTypeMap[sheetType],
      triggerRef: ref
    };
  }, [isDialogOpen, data, ref]);
  var renderSideSheet = function (sideSheetLayout) {
    return /* @__PURE__ */React4.createElement(EGDSSheetTransition2, {
      isVisible: isDialogOpen
    }, /* @__PURE__ */React4.createElement(EGDSSheet2, _object_spread_props(_object_spread({}, commonEGDSSheetProps), {
      sideSheetLayout: sideSheetLayout
    }), renderToolbar(), /* @__PURE__ */React4.createElement(EGDSSheetContent2, null, /* @__PURE__ */React4.createElement(ShoppingProductContentSectionGroupContentFC, {
      data: contentContainer
    }))));
  };
  var centerSheet = /* @__PURE__ */React4.createElement(DialogComponent, null, /* @__PURE__ */React4.createElement(EGDSSheet2, _object_spread({}, commonEGDSSheetProps), renderToolbar(), /* @__PURE__ */React4.createElement(EGDSSheetContent2, null, /* @__PURE__ */React4.createElement(ShoppingProductContentSectionGroupContentFC, {
    data: contentContainer
  }))));
  var smallView = /* @__PURE__ */React4.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React4.createElement(DialogComponent, null, /* @__PURE__ */React4.createElement(EGDSSheet2, {
    type: "full",
    isVisible: true,
    triggerRef: ref,
    returnFocusOnClose: true
  }, renderToolbar(), /* @__PURE__ */React4.createElement(EGDSSheetContent2, null, /* @__PURE__ */React4.createElement(ShoppingProductContentSectionGroupContentFC, {
    data: contentContainer
  })))));
  if (sheetType === "SIDE" /* SIDE */) {
    return /* @__PURE__ */React4.createElement(Viewport2, null, /* @__PURE__ */React4.createElement(ViewSmall2, null, smallView), /* @__PURE__ */React4.createElement(ViewMedium2, null, renderSideSheet({
      position: "trailing",
      columns: 6
    })), /* @__PURE__ */React4.createElement(ViewLarge, null, renderSideSheet({
      position: "trailing",
      columns: 4
    })));
  }
  if (sheetType === "CENTERED" /* CENTERED */) {
    return /* @__PURE__ */React4.createElement(Viewport2, null, /* @__PURE__ */React4.createElement(ViewSmall2, null, smallView), /* @__PURE__ */React4.createElement(ViewMedium2, null, centerSheet), /* @__PURE__ */React4.createElement(ViewLarge, null, centerSheet));
  }
  if (data.sheetType === "FULLSCREEN" /* FULLSCREEN */) {
    return /* @__PURE__ */React4.createElement(React4.Fragment, null, smallView);
  }
  if (data.sheetType === "POPOVER" /* POPOVER */) {
    return /* @__PURE__ */React4.createElement(ShoppingProductPopoverSheet, {
      actionId: actionId,
      contentContainer: contentContainer,
      ref: ref,
      closeDialog: closeDialog,
      closeText: data.closeText || ""
    });
  }
  return null;
});
ShoppingProductContentSectionGroupSheet.fragment = fragment;
ShoppingProductContentSectionGroupSheet.displayName = "ShoppingProductContentSectionGroupSheet";
// ../internal/src/components/shopping-product-content-section-group-overlay/shopping-product-content-section-group-overlay.tsx
var fragment2 = gql2(_templateObject1(), ShoppingProductContentSectionGroupSheet.fragment);
var ShoppingProductContentSectionGroupOverlay = React5.forwardRef(function (param, ref) {
  var data = param.data,
    actionId = param.actionId,
    contentContainer = param.contentContainer;
  var overlay = data.overlay;
  switch (overlay.__typename) {
    case "ShoppingCoachmark":
      return null;
    case "EGDSSheet":
    default:
      return /* @__PURE__ */React5.createElement(ShoppingProductContentSectionGroupSheet, {
        data: overlay,
        contentContainer: contentContainer,
        ref: ref,
        actionId: actionId
      });
  }
});
ShoppingProductContentSectionGroupOverlay.fragment = fragment2;
ShoppingProductContentSectionGroupOverlay.displayName = "ShoppingProductContentSectionGroupOverlay";
// ../internal/src/components/shopping-product-content-section-group/shopping-product-content-section-group-action-wrapper.tsx
var ShoppingProductContentSectionGroupActionWrapper = React6.forwardRef(function (param, ref) {
  var actionId = param.actionId,
    triggerComponent = param.triggerComponent;
  var contentSectionGroupAction = useContentSectionGroupAction(actionId);
  var contentSectionGroupUtils = useContentSectionGroupUtils();
  if ((contentSectionGroupAction === null || contentSectionGroupAction === void 0 ? void 0 : contentSectionGroupAction.__typename) === "ShoppingNavigateToOverlay") {
    var overlayContainer = contentSectionGroupUtils === null || contentSectionGroupUtils === void 0 ? void 0 : contentSectionGroupUtils.getOverlayContainer(contentSectionGroupAction.overlayId);
    var contentContainer = overlayContainer && (contentSectionGroupUtils === null || contentSectionGroupUtils === void 0 ? void 0 : contentSectionGroupUtils.getContentContainer(overlayContainer.contentId));
    if (!overlayContainer || !contentContainer) {
      return triggerComponent;
    }
    return /* @__PURE__ */React6.createElement(React6.Fragment, null, triggerComponent, /* @__PURE__ */React6.createElement(ShoppingProductContentSectionGroupOverlay, {
      data: overlayContainer,
      actionId: actionId,
      contentContainer: contentContainer,
      ref: ref
    }));
  }
  return triggerComponent;
});
ShoppingProductContentSectionGroupActionWrapper.displayName = "ShoppingProductContentSectionGroupActionWrapper";
// ../internal/src/components/shopping-link/shopping-link.tsx
var fragment3 = gql3(_templateObject2());
var ShoppingLink = function (param) {
  var data = param.data,
    inline = param.inline,
    onClickCb = param.onClick;
  var text = data.text,
    trailingIcon = data.trailingIcon,
    actionId = data.actionId;
  var triggerRef = React7.useRef(null);
  var contentSectionGroupActionCallback = useContentSectionGroupActionCallback(actionId);
  if (!actionId || !text) {
    return null;
  }
  if (onClickCb) {
    return /* @__PURE__ */React7.createElement(EGDSLink, {
      inline: inline !== null && inline !== void 0 ? inline : true
    }, /* @__PURE__ */React7.createElement("button", {
      type: "button",
      onClick: onClickCb,
      role: "link"
    }, /* @__PURE__ */React7.createElement("span", {
      "aria-label": text
    }, text), trailingIcon && /* @__PURE__ */React7.createElement(EGDSIcon2, {
      name: trailingIcon.id
    })));
  }
  return /* @__PURE__ */React7.createElement(ShoppingProductContentSectionGroupActionWrapper, {
    actionId: actionId,
    ref: triggerRef,
    triggerComponent: /* @__PURE__ */React7.createElement(EGDSLink, {
      inline: inline !== null && inline !== void 0 ? inline : true
    }, /* @__PURE__ */React7.createElement("button", {
      type: "button",
      onClick: contentSectionGroupActionCallback,
      role: "link"
    }, /* @__PURE__ */React7.createElement("span", {
      "aria-label": text
    }, text), trailingIcon && /* @__PURE__ */React7.createElement(EGDSIcon2, {
      name: trailingIcon.id
    })))
  });
};
ShoppingLink.fragment = fragment3;
ShoppingLink.displayName = "ShoppingLink";
// ../internal/src/components/shopping-product-content-section-action/shopping-product-content-section-action.tsx
var fragment4 = gql4(_templateObject3());
var ShoppingProductContentSectionAction = function (param) {
  var data = param.data;
  var __typename = data.__typename;
  switch (__typename) {
    case "ShoppingLink":
      return /* @__PURE__ */React8.createElement(ShoppingLink, {
        data: data,
        inline: false
      });
    default:
      return null;
  }
};
ShoppingProductContentSectionAction.displayName = "ShoppingProductContentSectionAction";
ShoppingProductContentSectionAction.fragment = fragment4;
// ../internal/src/components/shopping-product-content-sub-section/shopping-product-content-sub-section.tsx
import React21 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid4 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
// ../internal/src/components/shopping-product-content-element-group/shopping-product-content-element-group.tsx
import React20 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid3 } from "@egds/react-core/layout-grid";
// ../internal/src/components/shopping-product-content/shopping-product-content.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
// ../internal/src/components/shopping-product-content-item/shopping-product-content-item.tsx
import React17 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React10 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React9 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var _obj2;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj2 = {}, _define_property(_obj2, "INFO" /* INFO */, "info"), _define_property(_obj2, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj2, "WARNING" /* WARNING */, "warning"), _define_property(_obj2, "STANDARD" /* STANDARD */, "standard"), _obj2);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment5 = gql5(_templateObject4());
var EGDSIcon3 = function (param) {
  var className = param.className,
    defaultIconSize = param.defaultIconSize,
    data = param.data,
    spotlight = param.spotlight;
  var id = data.id,
    token = data.token;
  if (!id || !token) {
    return null;
  }
  var description = data.description,
    withBackground = data.withBackground,
    size = data.size,
    spotLightData = data.spotLight,
    title = data.title,
    theme = data.theme;
  return /* @__PURE__ */React9.createElement(UitkIcon, {
    className: className,
    description: description,
    id: id,
    name: token,
    shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
    size: size ? UitkIconSize[size] : defaultIconSize,
    spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : void 0
  });
};
EGDSIcon3.fragment = fragment5;
EGDSIcon3.displayName = "UitkIcon";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
var fragment6 = gql6(_templateObject5(), EGDSIcon3.fragment);
var EGDSGraphicText = function (param) {
  var data = param.data,
    textProps = param.textProps,
    _param_size = param.size,
    size = _param_size === void 0 ? 200 : _param_size;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    graphic = data.graphic;
  var graphicElement = function () {
    if (graphic.__typename === "Icon") {
      return /* @__PURE__ */React10.createElement(EGDSIcon3, {
        data: graphic
      });
    }
  };
  return /* @__PURE__ */React10.createElement(UitkText, _object_spread({
    size: size
  }, textProps), graphicElement(), text);
};
EGDSGraphicText.fragment = fragment6;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-heading/egds-heading.tsx
import React11 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSHeading as EGDSReactCoreHeading } from "@egds/react-core/text";
var fragment7 = gql7(_templateObject6());
var EGDSHeading2 = function (props) {
  var data = props.data,
    className = props.className,
    size = props.size,
    align = props.align,
    tag = props.tag;
  var accessibility = data.accessibility,
    text = data.text;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React11.createElement(EGDSReactCoreHeading, {
    className: className,
    size: size,
    align: align,
    tag: tag,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
  }, text);
};
EGDSHeading2.fragment = fragment7;
EGDSHeading2.displayName = "EGDSHeading";
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React12 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var _obj3;
// ../internal/src/components/egds-stylized-text/__private/mapper.ts
var UitkThemeMap = Object.freeze((_obj3 = {}, _define_property(_obj3, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj3, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj3, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj3, "default", "default"), _obj3));
var _obj4;
var UitkWeightMap = Object.freeze((_obj4 = {}, _define_property(_obj4, "BOLD" /* BOLD */, "bold"), _define_property(_obj4, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj4, "REGULAR" /* REGULAR */, "regular"), _obj4));
var UitkSizeMap = Object.freeze({
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
});
var DecorativeMap = Object.freeze({
  HIGHLIGHT: "mark",
  LINE_THROUGH: "s",
  SUBSCRIPT: "sub",
  SUPERSCRIPT: "sup",
  UNDERLINE: "u"
});
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
var fragment8 = gql8(_templateObject7());
var EGDSStylizedText = function (_param) {
  var data = _param.data,
    _param_theme = _param.theme,
    theme = _param_theme === void 0 ? "default" : _param_theme,
    _param_weight = _param.weight,
    weight = _param_weight === void 0 ? "regular" : _param_weight,
    _param_size = _param.size,
    size = _param_size === void 0 ? 300 : _param_size,
    props = _object_without_properties(_param, ["data", "theme", "weight", "size"]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    decorative = data.decorative,
    accessibility = data.accessibility;
  var textProps = _object_spread({
    theme: (data === null || data === void 0 ? void 0 : data.theme) ? UitkThemeMap[data.theme] : theme,
    weight: (data === null || data === void 0 ? void 0 : data.weight) ? UitkWeightMap[data.weight] : weight,
    size: (data === null || data === void 0 ? void 0 : data.size) ? UitkSizeMap[data.size] : size
  }, props);
  var Decorative = decorative && DecorativeMap[decorative];
  var content = Decorative ? /* @__PURE__ */React12.createElement(Decorative, null, text) : text;
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, /* @__PURE__ */React12.createElement(EGDSText2, _object_spread({
    "aria-hidden": Boolean(accessibility)
  }, textProps), content), accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSStylizedText.fragment = fragment8;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React13 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment9 = gql9(_templateObject8());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    align = param.align,
    data = param.data,
    spacing = param.spacing;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    accessibility = data.accessibility;
  return /* @__PURE__ */React13.createElement(UitkText2, {
    className: className,
    inline: inline,
    size: size,
    align: align,
    spacing: spacing
  }, text, accessibility && /* @__PURE__ */React13.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSPlainText.fragment = fragment9;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
var fragment10 = gql10(_templateObject9(), EGDSHeading2.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    headingProps = param.headingProps,
    data = param.data,
    inline = param.inline;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React14.createElement(EGDSHeading2, _object_spread({
        data: data
      }, headingProps));
    case "EGDSStylizedText":
      return /* @__PURE__ */React14.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React14.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React14.createElement(EGDSGraphicText, {
        data: data,
        size: size
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment10;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment11 = gql11(_templateObject10(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_inlineContent;
  var align = props.align,
    data = props.data,
    styleProps = _object_without_properties(props, ["align", "data"]);
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React15.createElement(React15.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React15.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index)
      }));
    }));
  }
  if (data === null || data === void 0 ? void 0 : data.text) {
    return /* @__PURE__ */React15.createElement(UitkText3, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align
    }), data.text);
  }
  return null;
};
EGDSSpannableText.fragment = fragment11;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/shopping-product-content-graphics-item/shopping-product-content-graphics-item.tsx
import React16 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var fragment12 = gql12(_templateObject11(), EGDSIcon3.fragment);
var ShoppingProductContentGraphicsItem = function (param) {
  var data = param.data;
  var text = data.text,
    leadingIcon = data.leadingIcon,
    state = data.state,
    trailingIcon = data.trailingIcon,
    impressionAnalytics = data.impressionAnalytics;
  var _ref = impressionAnalytics || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  var triggerRef = React16.useRef(null);
  var actionId = (trailingIcon || {}).actionId;
  var contentSectionGroupActionCallback = useContentSectionGroupActionCallback(actionId);
  var Text = /* @__PURE__ */React16.createElement(React16.Fragment, null, state === "DISABLED" ? /* @__PURE__ */React16.createElement("s", {
    "aria-hidden": true
  }, /* @__PURE__ */React16.createElement(EGDSText3, {
    size: 300,
    inline: true
  }, text)) : /* @__PURE__ */React16.createElement(EGDSText3, {
    size: 300,
    inline: true
  }, text), /* @__PURE__ */React16.createElement("span", {
    className: "is-visually-hidden"
  }, text));
  var TrailingIconWithTextLayout = /* @__PURE__ */React16.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    space: "one",
    blockSize: "full_size"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem2, null, Text), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem2, null, (trailingIcon === null || trailingIcon === void 0 ? void 0 : trailingIcon.icon) && /* @__PURE__ */React16.createElement(EGDSIcon3, {
    data: trailingIcon.icon,
    defaultIconSize: EGDSIconSize2.SMALL
  })));
  var TextWithTrailingIcon = actionId ? /* @__PURE__ */React16.createElement(ShoppingProductContentSectionGroupActionWrapper, {
    actionId: actionId,
    ref: triggerRef,
    triggerComponent: /* @__PURE__ */React16.createElement(EGDSMoreInfoTrigger, {
      onClick: contentSectionGroupActionCallback
    }, /* @__PURE__ */React16.createElement("button", {
      type: "button",
      "data-stid": "sp-graphics-item-actionable-icon",
      ref: triggerRef
    }, TrailingIconWithTextLayout))
  }) : TrailingIconWithTextLayout;
  var TextItem = (trailingIcon === null || trailingIcon === void 0 ? void 0 : trailingIcon.icon) ? TextWithTrailingIcon : Text;
  var TextItemLayout = /* @__PURE__ */React16.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    blockSize: "full_size"
  }, TextItem);
  var GraphicsText = referrerId && linkName ? /* @__PURE__ */React16.createElement(IntersectionTracker, {
    trackOnce: true,
    linkName: linkName,
    referrerId: referrerId
  }, TextItemLayout) : TextItemLayout;
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, leadingIcon && /* @__PURE__ */React16.createElement(EGDSSpacing2, {
    padding: {
      inlineend: "two"
    }
  }, /* @__PURE__ */React16.createElement(EGDSIcon3, {
    data: leadingIcon
  })), GraphicsText);
};
ShoppingProductContentGraphicsItem.displayName = "ShoppingProductContentGraphicsItem";
ShoppingProductContentGraphicsItem.fragment = fragment12;
// ../internal/src/components/shopping-product-content-item/shopping-product-content-item.tsx
var fragment13 = gql13(_templateObject12(), ShoppingProductContentGraphicsItem.fragment, EGDSPlainText.fragment);
var ShoppingProductContentItem = function (param) {
  var data = param.data;
  var __typename = data.__typename;
  switch (__typename) {
    case "ShoppingProductContentGraphicsItem":
      return /* @__PURE__ */React17.createElement(ShoppingProductContentGraphicsItem, {
        data: data
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React17.createElement(EGDSPlainText, {
        data: data
      });
    default:
      return null;
  }
};
ShoppingProductContentItem.displayName = "ShoppingProductContentItem";
ShoppingProductContentItem.fragment = fragment13;
// ../internal/src/components/shopping-product-header/shopping-product-header.tsx
import React18 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
var __ShoppingProductHeaderFragment = gql14(_templateObject13());
var ShoppingProductHeader = function (param) {
  var data = param.data,
    _param_headingTag = param.headingTag,
    headingTag = _param_headingTag === void 0 ? "h3" : _param_headingTag,
    _param_headingSize = param.headingSize,
    headingSize = _param_headingSize === void 0 ? 5 : _param_headingSize;
  var _useExperiment_exposure = useExperiment("Remove_About_the_Property_Web").exposure,
    isTopOfPDPRedesignVariant = _useExperiment_exposure.bucket;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    impressionAnalytics = data.impressionAnalytics,
    subText = data.subText;
  var _ref = impressionAnalytics || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  var Header = /* @__PURE__ */React18.createElement(EGDSHeading3, {
    tag: headingTag,
    size: headingSize,
    "data-testid": "sp-header"
  }, text);
  var SubText = subText ? /* @__PURE__ */React18.createElement(EGDSSpacing3, {
    padding: {
      blockstart: isTopOfPDPRedesignVariant ? "one" : "two"
    }
  }, /* @__PURE__ */React18.createElement(EGDSText4, {
    size: 300,
    "data-testid": "amenities-subtext"
  }, subText)) : null;
  if (referrerId && linkName) {
    return /* @__PURE__ */React18.createElement(IntersectionTracker2, {
      trackOnce: true,
      linkName: linkName,
      referrerId: referrerId
    }, Header, SubText);
  }
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, Header, SubText);
};
ShoppingProductHeader.displayName = "ShoppingProductHeader";
ShoppingProductHeader.fragment = __ShoppingProductHeaderFragment;
// ../internal/src/components/shopping-product-content/shopping-product-content.tsx
var fragment14 = gql15(_templateObject14(), ShoppingProductHeader.fragment, ShoppingProductContentItem.fragment);
var ShoppingProductContent = function (param) {
  var data = param.data;
  var _items_;
  var header = data.header,
    items = data.items,
    maxColumns = data.maxColumns;
  var isGraphicItem = items.length > 0 && ((_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.__typename) === "ShoppingProductContentGraphicsItem" && items[0].leadingIcon;
  var bullet = isGraphicItem ? "icon-alternate" : "default";
  var isSmallViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.SMALL;
  var _space = isSmallViewSize ? "two" : "three";
  var gridSpace = isGraphicItem ? _space : void 0;
  if (!header && items.length <= 0) {
    return null;
  }
  return /* @__PURE__ */React19.createElement(EGDSLayoutGridItem2, {
    colSpan: 1,
    "data-stid": "sp-content"
  }, /* @__PURE__ */React19.createElement(React19.Fragment, null, header && /* @__PURE__ */React19.createElement(ShoppingProductHeader, {
    data: header
  }), (items === null || items === void 0 ? void 0 : items.length) > 0 && /* @__PURE__ */React19.createElement(EGDSList, {
    spacing: false,
    bullet: bullet,
    size: 2,
    type: "unordered",
    "data-stid": "sp-content-list"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutGrid2, {
    space: gridSpace,
    columns: maxColumns
  }, items.map(function (item, idx) {
    return /* @__PURE__ */React19.createElement(EGDSListItem, {
      key: "sp-content-item-".concat(idx),
      "data-stid": "sp-content-item-".concat(idx)
    }, /* @__PURE__ */React19.createElement(ShoppingProductContentItem, {
      data: item
    }));
  })))));
};
ShoppingProductContent.displayName = "ShoppingProductContent";
ShoppingProductContent.fragment = fragment14;
// ../internal/src/components/shopping-product-content-element-group/shopping-product-content-element-group.tsx
var fragment15 = gql16(_templateObject15(), ShoppingProductContent.fragment);
var ShoppingProductContentElementGroup = function (param) {
  var data = param.data;
  var elements = data.elements,
    _data_maxColumns = data.maxColumns,
    maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
  var renderedElements = elements.map(function (element, index) {
    switch (element.__typename) {
      case "ShoppingProductContent":
        return /* @__PURE__ */React20.createElement(ShoppingProductContent, {
          key: "sp-product-content-".concat(index),
          data: element
        });
      default:
        return null;
    }
  });
  return /* @__PURE__ */React20.createElement(React20.Fragment, null, (elements === null || elements === void 0 ? void 0 : elements.length) > 0 && /* @__PURE__ */React20.createElement(EGDSLayoutGrid3, {
    columns: maxColumns
  }, renderedElements));
};
ShoppingProductContentElementGroup.displayName = "ShoppingProductContentElementGroup";
ShoppingProductContentElementGroup.fragment = fragment15;
// ../internal/src/components/shopping-product-content-sub-section/shopping-product-content-sub-section.tsx
var fragment16 = gql17(_templateObject16(), ShoppingProductHeader.fragment, ShoppingProductContentElementGroup.fragment);
var ShoppingProductContentSubSection = function (param) {
  var data = param.data;
  var header = data.header,
    elements = data.elements,
    _data_maxColumns = data.maxColumns,
    maxColumns = _data_maxColumns === void 0 ? 1 : _data_maxColumns;
  return /* @__PURE__ */React21.createElement(React21.Fragment, null, header && /* @__PURE__ */React21.createElement(ShoppingProductHeader, {
    data: header
  }), (elements === null || elements === void 0 ? void 0 : elements.length) > 0 && /* @__PURE__ */React21.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React21.createElement(EGDSLayoutGrid4, {
    space: "three",
    columns: {
      small: 1,
      medium: maxColumns
    }
  }, elements.map(function (elem, ind) {
    return /* @__PURE__ */React21.createElement(ShoppingProductContentElementGroup, {
      data: elem,
      key: "sp-element-group-".concat(ind)
    });
  }))));
};
ShoppingProductContentSubSection.displayName = "ShoppingProductContentSubSection";
ShoppingProductContentSubSection.fragment = fragment16;
// ../internal/src/components/shopping-product-content-section/shopping-product-content-section.tsx
var fragment17 = gql18(_templateObject17(), ShoppingProductHeader.fragment, ShoppingProductContentSubSection.fragment, ShoppingProductContentSectionAction.fragment);
var ShoppingProductContentSection = function (param) {
  var data = param.data;
  var _useExperiment2_exposure = useExperiment2("PDP_MODULARISED_LOCATION_SECTION").exposure,
    isModularised = _useExperiment2_exposure.bucket;
  var header = data.header,
    subSections = data.subSections,
    action = data.action,
    impressionAnalytics = data.impressionAnalytics;
  var _ref = impressionAnalytics || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  var actionContentSection = action && /* @__PURE__ */React22.createElement(ShoppingProductContentSectionAction, {
    data: action
  });
  var ContentSection = /* @__PURE__ */React22.createElement(EGDSSpacing5, {
    padding: {
      blockend: "four"
    }
  }, /* @__PURE__ */React22.createElement(EGDSLayoutGrid5, {
    space: "three",
    columns: {
      medium: 1,
      large: 1
    }
  }, header && /* @__PURE__ */React22.createElement(ShoppingProductHeader, {
    data: header,
    headingSize: isModularised ? 4 : void 0,
    headingTag: isModularised ? "h2" : void 0
  }), (subSections === null || subSections === void 0 ? void 0 : subSections.length) > 0 && subSections.map(function (subSection, index) {
    return /* @__PURE__ */React22.createElement("div", {
      key: "sp-content-sub-section-".concat(index)
    }, /* @__PURE__ */React22.createElement(ShoppingProductContentSubSection, {
      data: subSection
    }));
  }), actionContentSection));
  if (referrerId && linkName) {
    return /* @__PURE__ */React22.createElement(IntersectionTracker3, {
      trackOnce: true,
      referrerId: referrerId,
      linkName: linkName
    }, ContentSection);
  }
  return /* @__PURE__ */React22.createElement(React22.Fragment, null, ContentSection);
};
ShoppingProductContentSection.displayName = "ShoppingProductContentSection";
ShoppingProductContentSection.fragment = fragment17;
// ../internal/src/components/shopping-product-content-section-group-content/shopping-product-content-section-group-content.tsx
var fragment18 = gql19(_templateObject18(), ShoppingProductContentSection.fragment);
var ShoppingProductContentSectionGroupContent = function (param) {
  var data = param.data;
  return /* @__PURE__ */React23.createElement(ShoppingProductContentSectionGroupContentFC, {
    data: data
  });
};
ShoppingProductContentSectionGroupContent.fragment = fragment18;
ShoppingProductContentSectionGroupContent.displayName = "ShoppingProductContentSectionGroupContent";
// src/components/__private/__fragments/amenities-content-section/amenities-content-section.tsx
import React24 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSLayoutGrid as EGDSLayoutGrid6 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { PropertySeeAllAmenities } from "@shared-ui/lodging-property-details";
var fragment19 = gql20(_templateObject19(), ShoppingProductHeader.fragment, ShoppingProductContentSubSection.fragment, ShoppingProductContentSectionAction.fragment);
var AmenitiesContentSection = function (param) {
  var data = param.data,
    inputs = param.inputs,
    isModal = param.isModal;
  var _inputs_productIdentifier, _inputs_productIdentifier_travelSearchCriteria, _inputs_productIdentifier1;
  var _useExperiment3_exposure = useExperiment3("PDP_MODULARISED_LOCATION_SECTION").exposure,
    isModularised = _useExperiment3_exposure.bucket;
  var _useExperiment3 = useExperiment3("Remove_About_the_Property_Web"),
    topOfPDPRedesignExposure = _useExperiment3.exposure;
  var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
  var header = data.header,
    subSections = data.subSections,
    action = data.action,
    impressionAnalytics = data.impressionAnalytics;
  var _ref = impressionAnalytics || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  var inputsTransformed = {
    propertyId: (inputs === null || inputs === void 0 ? void 0 : (_inputs_productIdentifier = inputs.productIdentifier) === null || _inputs_productIdentifier === void 0 ? void 0 : _inputs_productIdentifier.id) || "",
    searchCriteria: (inputs === null || inputs === void 0 ? void 0 : (_inputs_productIdentifier1 = inputs.productIdentifier) === null || _inputs_productIdentifier1 === void 0 ? void 0 : (_inputs_productIdentifier_travelSearchCriteria = _inputs_productIdentifier1.travelSearchCriteria) === null || _inputs_productIdentifier_travelSearchCriteria === void 0 ? void 0 : _inputs_productIdentifier_travelSearchCriteria.property) || void 0
  };
  var modularisedGridSpace = isModularised ? void 0 : "four";
  var gridSpace = isTopOfPDPRedesignVariant ? modularisedGridSpace : "three";
  var actionContentSection = isTopOfPDPRedesignVariant && inputs ? /* @__PURE__ */React24.createElement(EGDSSpacing6, {
    padding: {
      blockstart: isModularised ? "four" : void 0
    }
  }, /* @__PURE__ */React24.createElement("div", null, /* @__PURE__ */React24.createElement(PropertySeeAllAmenities, {
    inputs: inputsTransformed,
    skipSsr: true
  }))) : action && /* @__PURE__ */React24.createElement(ShoppingProductContentSectionAction, {
    data: action
  });
  var ContentSection = /* @__PURE__ */React24.createElement(EGDSSpacing6, {
    padding: isModularised && !isModal ? void 0 : {
      blockend: "four"
    }
  }, /* @__PURE__ */React24.createElement(EGDSLayoutGrid6, {
    space: gridSpace,
    columns: {
      medium: 1,
      large: 1
    }
  }, header && /* @__PURE__ */React24.createElement(ShoppingProductHeader, {
    data: header,
    headingSize: 4,
    headingTag: "h2"
  }), (subSections === null || subSections === void 0 ? void 0 : subSections.length) > 0 && subSections.map(function (subSection, index) {
    return /* @__PURE__ */React24.createElement("div", {
      key: "sp-content-sub-section-".concat(index)
    }, /* @__PURE__ */React24.createElement(ShoppingProductContentSubSection, {
      data: subSection
    }));
  }), actionContentSection));
  if (referrerId && linkName) {
    return /* @__PURE__ */React24.createElement(IntersectionTracker4, {
      trackOnce: true,
      referrerId: referrerId,
      linkName: linkName
    }, ContentSection);
  }
  return /* @__PURE__ */React24.createElement(React24.Fragment, null, ContentSection);
};
AmenitiesContentSection.displayName = "AmenitiesContentSection";
AmenitiesContentSection.fragment = fragment19;
// src/components/__private/__fragments/amenities-content-section-group/amenities-content-section-group.tsx
var fragment20 = gql21(_templateObject20(), ShoppingProductContentSectionGroupOverlay.fragment, ShoppingProductContentSectionGroupContent.fragment, AmenitiesContentSection.fragment);
var AmenitiesContentSectionGroup = function (param) {
  var data = param.data,
    _param_padding = param.padding,
    padding = _param_padding === void 0 ? {
      blockend: "four"
    } : _param_padding,
    inputs = param.inputs;
  var _useExperiment4_exposure = useExperiment4("PDP_MODULARISED_LOCATION_SECTION").exposure,
    isModularised = _useExperiment4_exposure.bucket;
  var sections = data.sections,
    impressionAnalytics = data.impressionAnalytics;
  var _ref = impressionAnalytics || {},
    referrerId = _ref.referrerId,
    linkName = _ref.linkName;
  if (!sections || sections.length === 0) {
    return null;
  }
  var sectionGroupContent = /* @__PURE__ */React25.createElement(ShoppingProductContentSectionGroupProvider, {
    data: data
  }, /* @__PURE__ */React25.createElement(EGDSSpacing7, {
    padding: isModularised ? {
      blockend: "six"
    } : padding
  }, /* @__PURE__ */React25.createElement("div", null, sections.map(function (section, index) {
    return /* @__PURE__ */React25.createElement(AmenitiesContentSection, {
      data: section,
      key: "sp-content-section-".concat(index),
      inputs: inputs
    });
  }))));
  if (referrerId && linkName) {
    return /* @__PURE__ */React25.createElement(IntersectionTracker5, {
      trackOnce: true,
      linkName: linkName,
      referrerId: referrerId
    }, sectionGroupContent);
  }
  return /* @__PURE__ */React25.createElement(React25.Fragment, null, sectionGroupContent);
};
AmenitiesContentSectionGroup.displayName = "AmenitiesContentSectionGroup";
AmenitiesContentSectionGroup.fragment = fragment20;
// src/components/amenities/amenities.tsx
var __Query = gql22(_templateObject21(), AmenitiesContentSectionGroup.fragment);
var Amenities = function (props) {
  var _mockData_product, _mockData_product1;
  var inputs = props.inputs,
    batchKey = props.batchKey,
    skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
  var _useExperiment5 = useExperiment5("Remove_About_the_Property_Web"),
    topOfPDPRedesignExposure = _useExperiment5.exposure;
  var isTopOfPDPRedesignVariant = topOfPDPRedesignExposure.bucket === 1;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var mockData = useMockData();
  var _useQuery = useQuery(__Query, {
      context: {
        useApq: true,
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr,
      skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.amenities
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var amenitiesData = (data === null || data === void 0 ? void 0 : data.amenities) || (mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.amenities);
  if (loading || error || !amenitiesData) {
    return null;
  }
  return /* @__PURE__ */React26.createElement(RefTarget, {
    name: isTopOfPDPRedesignVariant ? "About" : "PopularAmenities"
  }, /* @__PURE__ */React26.createElement(AmenitiesContentSectionGroup, {
    data: amenitiesData,
    padding: {
      blockend: "two"
    },
    inputs: isTopOfPDPRedesignVariant ? inputs : void 0
  }));
};
Amenities.displayName = "sharedui-Amenities";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
  return IdentifierType2;
}(IdentifierType || {});
export { Amenities, IdentifierType };